// Helpers for the create-balanced-scorecard action flow: form field keys per module,
// per-instance completeness, and the bulk-create payload builders.

// The DB module omits budget/group; the backend derives the employee's own group.
export const createFormKeys = (isDbModuleActive) => (
  isDbModuleActive
    ? ['balanced_scorecard_template_group', 'balanced_scorecard_template']
    : ['balanced_scorecard_template', 'budget', 'group']
);

export const requiredCreateFormKeys = (isDbModuleActive) => (
  isDbModuleActive
    ? ['balanced_scorecard_template_group', 'balanced_scorecard_template']
    : ['balanced_scorecard_template']
);

export const instanceComplete = (formKeys, vals) => formKeys.every(key => !!vals?.[key]);

// balanced_scorecard_template_group is a UI-only selector - only the template is sent.
export const buildOverwritePayload = ({ filters, selected, values, isDbModuleActive }) => ({
  filters: filters || [],
  employee_hash_ids: selected,
  balanced_scorecard_template: values.balanced_scorecard_template,
  ...(isDbModuleActive ? {} : {
    rating_mode: values?.rating_mode,
    budget: values.budget || null,
    group: values.group || null,
  }),
});

export const buildInstanceUpdatesPayload = ({ instanceChecked, instanceValues, isDbModuleActive }) => ({
  updates: instanceChecked.map(hash => ({
    employee_hash_id: hash,
    balanced_scorecard_template: instanceValues[hash]?.balanced_scorecard_template,
    ...(isDbModuleActive ? {} : {
      rating_mode: instanceValues[hash]?.rating_mode,
      budget: instanceValues[hash]?.budget || null,
      group: instanceValues[hash]?.group || null,
    }),
  })),
});
